import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import { AppBody } from './components/AppBody';
import { Login } from './components/auth/Login';
import { Roles } from './components/admin/Roles';
import { CreateRole } from './components/admin/CreateRole';
import { AccessDenied } from './components/util/AccessDenied';
import './custom.css'
import { Users } from './components/admin/Users';
import { RoleDetails } from './components/admin/RoleDetails';
import { UserDetails } from './components/admin/UserDetails';
import { Admin } from './components/admin/Admin';
import { ViewFiles } from './components/ViewFiles';
import { Logout } from './components/auth/Logout';
import { ForgotPassword } from './components/ForgotPassword';
import { ResetPassword } from './components/ResetPassword';
import { FileDetails } from './components/FileDetails';
import { NotFound } from './components/util/NotFound';

export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <AppBody>
                <Switch>
                    <Route exact path='/' component={ViewFiles} />
                    <Route path='/viewfiles' component={ViewFiles} />
                    <Route path='/forgotpassword' component={ForgotPassword} />
                    <Route path='/resetpassword' component={ResetPassword} />
                    <Route path='/filedetails' component={FileDetails} />

                    <Route exact path='/admin' component={Admin} />
                    <Route exact path='/admin/roles' component={Roles} />
                    <Route exact path='/admin/roles/create' component={CreateRole} />
                    <Route exact path='/admin/roles/details' component={RoleDetails} />
                    <Route exact path='/admin/users' component={Users} />
                    <Route exact path='/admin/users/details' component={UserDetails} />

                    <Route exact path='/accessdenied' component={AccessDenied} />
                    <Route exact path='/login' component={Login} />
                    <Route exact path='/logout' component={Logout} />

                    {/* Catch-all must be last */}
                    <Route component={NotFound} />
                </Switch>
            </AppBody>
        );
    }
}